import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import '../assets/css/components/content-card.css'

const AddNewCard = ({ titleText, subtitleText, labelContents, link, onClick }) => {
  const blankFunction = ()=>{}

  return(
    <div onClick={onClick || blankFunction} className="col-md-6 col-lg-4 col-xl-3 m-b-10 content-card">
      <div className="ar-1-1">
        <div className="card no-border bg-info-dark widget widget-loader-circle-lg no-margin">
          {link && <Link to={link} className='ab-link'></Link>}
          <div className="card-block">
            <div className="pull-bottom bottom-left bottom-right padding-25">
              <span className="label font-montserrat fs-11">
                {labelContents || <i className='fa fa-plus'></i>}
              </span>
              <br/>
              <h3 className="text-white">{titleText}</h3>
              {subtitleText && <p className="text-white hint-text hidden-lg-down">{subtitleText}</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

AddNewCard.propTypes = {
  titleText: PropTypes.string.isRequired
}

export default AddNewCard;
